// @ts-check
import execute from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/execute';

/**
 * @typedef {import('./buildPadPrescriptionEvent').DtEvent} DtEvent
 * @typedef {import('./transformPadPrescriptionsToPrescriptionLoadSchedule').PadVisit} PadVisit
 * @typedef {import('app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/types/SchedulePrescription').SchedulePrescription} SchedulePrescription
 */

/**
 * Coleta e executa as prescrições filtradas por padVisitId, transformando-as em eventos de data/hora.
 *
 * @param {SchedulePrescription[]} prescriptionSchedulesArray - Array de objetos de prescrição (cada um com padVisitId, pad, etc.)
 * @param {PadVisit} padVisit - Objeto da visita PAD contendo id, totalAmount, maxTimeDifferenceMinutes
 * @returns {DtEvent[]} Array achatado de eventos com padPrescriptionId e padPrescription enriquecidos
 */
export function collectPrescriptionDateTimeEvents(prescriptionSchedulesArray, padVisit) {
  const { id: padVisitId } = padVisit;

  /** @type {DtEvent[]} */
  const allDateTimePrescriptionEvents = [];

  prescriptionSchedulesArray
    .filter(presc => presc.padVisitId === padVisitId)
    .forEach(padPrescription => {
      const { id: padPrescriptionId, pad, padPrescriptionSuggestionScheduling } = padPrescription;
      const hasSuggestion = padPrescriptionSuggestionScheduling.length > 0;

      if (!hasSuggestion) {
        return;
      }

      let dateTimeEvents = [];

      try {
        dateTimeEvents = execute(padPrescription, pad);
      } catch (error) {
        throw new Error('Something wrong!');
      }

      if (!Array.isArray(dateTimeEvents)) {
        return;
      }

      dateTimeEvents.forEach(dtEvent => {
        allDateTimePrescriptionEvents.push({ ...dtEvent, padPrescriptionId, padPrescription });
      });
    });

  return allDateTimePrescriptionEvents;
}
